import { FORM_FIELD_TYPES } from "../lib/formBuilder/apiFieldTypes";

export function useFormFieldTypes() {
  return { fieldTypes: FORM_FIELD_TYPES, isLoadingFieldTypes: false };
}
